import { render, staticRenderFns } from "./klsz.vue?vue&type=template&id=1c2ab08d&"
import script from "./klsz.vue?vue&type=script&lang=js&"
export * from "./klsz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContentType5: require('D:/Project/kpwebsite/PC/components/content/content-type-5.vue').default})
